/**
 * Created by mykurisu on 2017/8/28.
 */
import React from 'react'
import {Link} from 'react-router'
import {connect} from 'react-redux'
import axios from 'axios'
import qr from 'qr-encode'
import {Page} from '../components'
import {isQQ, isAlipay} from '../utils'
import '../css/page/PaySuccess.css'

class PaySuccess extends React.Component {
    constructor() {
        super();
        this.state = {
            recommends: null,
            qrcode: null,
            isB: true,
        };
    }

    mta (payload) {
        this.props.dispatch({
            type: 'MTA_CLICK',
            payload: payload,
        })
    }

    fetchQrcode (liveroomId, objectId, objectType) {
        const {query} = this.props.location;
        let params = {
            object_id: objectId,
            object_type: objectType,
            promote_flag: 0,
        }
        if (query.nsid) {
            params.nsid = query.nsid
        }
        if (query.lfr) {
            params.lfr = query.lfr
        }
        axios.get(`/api/liveroom/${liveroomId}/get_qrcode`, {
            params
        }).then(res => {
            if (res.data.code === 0) {
                this.setState({
                    qrcode: res.data.data.qrcode_content
                })
            }
        })
    }

    componentDidMount() {
        const data = this.props.routeParams;
        const isB = this.state.isB

        if (data.type === 'lecture'){
            axios.get(`/api/lecture/${data.id}/info`)
                .then(res => {
                    if (res.data.code === 0) {
                        this.setState({ lecture: res.data.data.lecture })
                        if (!this.props.account.subscribed){
                            this.mta('unsubscribed_enter_lecture_paysuccess')
                        }
                    }
                    this.fetchQrcode( res.data.data.liveroom.id, res.data.data.lecture.id, isB ? 'pay_lecture1' : 'pay_lecture')
                })
        } else if(data.type === 'channel'){
            axios.get(`/api/channel/${data.id}/info`)
                .then(res => {
                    if (res.data.code === 0) {
                        this.setState({ channel: res.data.data.channel })
                        if (!this.props.account.subscribed){
                            this.mta('unsubscribed_enter_channel_paysuccess')
                        }
                    }
                    this.fetchQrcode(res.data.data.liveroom.id, res.data.data.channel.id, isB ? 'pay_channel1' : 'pay_channel')
                })
        }else if(data.type === 'liveroom') {
            axios.get(`/api/liveroom/${data.id}/info`)
            .then(res => {
                if (res.data.code === 0) {
                    this.setState({ liveroom: res.data.data.liveroom })
                    if (!this.props.account.subscribed){
                        this.mta('unsubscribed_enter_liveroom_paysuccess')
                    }
                }
                this.fetchQrcode(res.data.data.liveroom.id, res.data.data.liveroom.id,  'pay_liveroom_vip')
            })
        }else {
            axios.get('/api/member/get_qrcode')
            .then((res) => {
                if(res.data.code === 0) {
                    this.setState({
                        qrcode: res.data.data.qrcode_content
                    })
                }
            })
        }
        if (data.type !== 'liveroom') {
            this.fetchRecommends()
        }
        this.mta('lecture_channel_paysuccess')
        if (isB) {
            this.mta('lecture_channel_paysuccess_b')
        }
    }

    fetchRecommends () {
        axios.get(`/api/recommend/channels`, {params: {limit: 3}})
            .then(res => {
                if (res.data.code === 0 && res.data.data.channels.length > 0) {
                    this.setState({ recommends: res.data.data.channels })
                }
            }).catch(res => console.log(res, 'err'))
    }

    renderLink() {
        const data = this.props.routeParams;
        const {query} = this.props.location;
        if (query.st) {
            if (query.st === 'pay_gift_lecture' || query.st === 'pay_gift_channel') {
                return "/account/bought"
            }
            if (query.st === 'accept_gift') {
                if (data.type === 'lecture') return `/lecture/${data.id}`
                if (data.type === 'channel') return `/channel/${data.id}`
            }
            return "/account/bought"
        }else {
            if (data.type === 'channel') {
                return `/channel/${data.id}`
            }else if (data.type === 'lecture') {
                return `/lecture/${data.id}`
            } else if (data.type === 'liveroom') {
                return `/liveroom/${query.liveroom_id}`
            } else {
                return `/supervip`
            }
        }
    }

    render() {
        const {recommends, qrcode, isB} = this.state;
        const {account} = this.props;
        const data = this.props.routeParams;
        const link = this.renderLink();
        const {query} = this.props.location;
        const isNewResell = (window.location.pathname.indexOf('channel') || window.location.pathname.indexOf('lecture')) && query.lfr && query.nsid !== 'pgy'
        const isCPS = !!query.lfr
        return (
            <Page>
                <div className="pay-success-page">
                    <div className="pay-success-header">
                        <div className="header-tips-icon">
                            <i className="weui-icon-success weui-icon_msg"/>
                        </div>
                        {data.type === 'svip' &&
                        <p className="header-check">超级会员</p>
                        }
                        {isQQ() && (
                            <div>
                                <Link to={`/account/edit/phone`}>
                                    <div className="header-button download-app-btn">
                                        下载APP 课程永久回听
                                    </div>
                                </Link>
                                <Link to={`/account/bought`}>
                                    <div className="header-button see-bought">
                                        查看购买记录
                                    </div>
                                </Link>
                            </div>
                        )}
                        {!isNewResell ? 
                        <a href={link}><div className="header-button">查看详情</div></a>
                        :
                        <div className="pay-success-tips">购买成功</div>
                        }
                    </div>
                    <div className="pay-success-bd">
                        {/*渠道过来的专栏或者单课购买不管有没有授权都直接显示这个返回二维码*/}
                        {(isNewResell || query.nsid === 'pgy') &&
                            <div className='flat-qr'>
                                <p className="flat-title">长按识别二维码关注公众号</p>
                                <p className="content__qrcode"><img src={qr(qrcode)} alt="" /></p>
                                <p className="flat-tips"><b>请务必关注 否则无法听课</b></p>
                            </div>
                        }

                        {!account.subscribed && !account.subscribed_retain && !query.lfr &&
                            (!isQQ() && !isAlipay() &&
                                <div className='flat-qr'>
                                    <p className="flat-title">长按识别二维码关注公众号听课</p>
                                    <p className="content__qrcode"><img src={qr(qrcode)} alt=""/></p>
                                    <p className="flat-tips"><b>否则将无法收到上课通知</b></p>
                                </div>
                            )
                        }

                        {!isCPS && (account.subscribed || (!account.subscribed && account.subscribed_retain)) &&
                            <div className="flat-subscribed text-center">
                                可在<Link to="/account/" className="flat-link">【个人中心】</Link> - <Link to="/account/bought" className="flat-link">【购买记录】</Link>中查看
                            </div>}

                      </div>

                    {(account.subscribed || (!account.subscribed && account.subscribed_retain)) && recommends && recommends.length && !query.lfr> 0 &&
                    <div className="pay-success-more">
                        <p className="more-title">猜你喜欢</p>
                        <div className="more-list">
                            {recommends.map((item) => (
                            <a href={data.type === 'lecture' ? `/channel/${item.id}?inviter_id=45269191` : `/channel/${item.id}?inviter_id=45269191`} key={item.id} className='wk-currency-item currency-item-border-top'>
                                <div className="currency-item-left">
                                    <div className="currency-item-img background-image" style={{backgroundImage: `url(${item.cover_url})`}}/>
                                </div>
                                <div className="currency-item-right">
                                    <div className="currency-item-right-title">{item.name}</div>
                                </div>
                            </a>
                            ))}
                        </div>
                    </div>
                    }
                </div>
            </Page>
        )
    }
}

export default connect(state => ({
    account: state.account
}))(PaySuccess)



// WEBPACK FOOTER //
// ./src/pages/PaySuccess.js